import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import RootRef from '@material-ui/core/RootRef';
import DataGrid from '../../data/Grid';
import Breadcrumbs from '../../core/Breadcrumbs';
import Icon from '../../core/Icon';
import ModalWindow from '../../modal/Window';
import Modal from '../../modal';
import DataAction from '../../data/actions';
import DataSelectFormInput from '../../form/input/DataSelect';
import RepositoryUpload from '../../core/RepositoryUpload';
import InputLabel from '@material-ui/core/InputLabel';
import { HotKeys } from 'react-hotkeys';
import { getTypeExtensions, getTypeFriendlyName } from './fileTypes';
import NavigationButtonGroup from './NavigationButtonGroup';
import stripDesignTrunkFromPath from '../../utils/pathUtil/stripDesignTrunkFromPath';
import getFolderPath from '../../utils/pathUtil/getFolderPath';
import getParentFolderPath from '../../utils/pathUtil/getParentFolderPath';
import isFolder from '../../utils/pathUtil/isFolder';
import isFile from '../../utils/pathUtil/isFile';
import isMobileDevice from '../../utils/getMobileOS/isMobileDevice';
import addDesignTrunk from '../../utils/pathUtil/addDesignTrunk';
import { withStyles, createStyles } from '@material-ui/core/styles';
var PICKER_BACKGROUND = '#F8F8F8';
var KEY_MAP = {
  NAVIGATE_UP: ['alt+up', 'ctrl+up', 'command+up'],
  NEW_FOLDER: ['alt+n'],
  BACK: ['backspace', 'alt+left'],
  FORWARD: ['alt+right']
};
var styles = createStyles({
  buttonsGrey: {
    '&:hover': {
      backgroundColor: "#F3F5F7"
    },
    '&:focus': {
      backgroundColor: "#E0E5EB"
    }
  }
});

var getItemPath = function getItemPath(item) {
  return stripDesignTrunkFromPath(item.Path);
};
/**
 * @extends {React.Component<import('./types').RepositoryPickerProps> }
 */


var RepositoryPicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RepositoryPicker, _React$Component);

  function RepositoryPicker(props) {
    var _this;

    _classCallCheck(this, RepositoryPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RepositoryPicker).call(this, props));

    _this.focus = function () {
      if (_this.gridViewRef.current) {
        _this.gridViewRef.current.focus({
          preventScroll: true
        });
      }
    };

    _this.onBeforeNavigation = function () {
      _this.history.back.push({
        workspace: _this.state.workspace,
        path: _this.state.path
      });

      _this.history.forward = [];
    };

    _this.navigateToWorkspace = function (workspace) {
      if (_this.state.workspace !== workspace) {
        _this.onBeforeNavigation();

        _this.setState({
          workspace: workspace,
          path: ''
        });
      }
    };

    _this.navigateToPath = function (path) {
      if (_this.state.path !== path) {
        _this.onBeforeNavigation();

        _this.setState({
          path: path
        });
      }
    };

    _this.hasUp = function () {
      if (!_this.state.path) return false;
      return true;
    };

    _this.goUp = function (e) {
      if (!_this.hasUp()) return false;

      var segments = _this.state.path.split('/');

      segments.pop();
      var newPath = segments.join('/');

      _this.handleChangePath(newPath);

      return true;
    };

    _this.hasBack = function () {
      if (!_this.history.back.length) return false;
      return true;
    };

    _this.goBack = function (e) {
      if (!_this.hasBack()) return false;
      var crt = {
        workspace: _this.state.workspace,
        path: _this.state.path
      };

      _this.history.forward.unshift(crt);

      var lastEntry = _this.history.back.pop();

      _this.setState(lastEntry);

      return true;
    };

    _this.hasForward = function () {
      if (!_this.history.forward.length) return false;
      return true;
    };

    _this.goForward = function (e) {
      if (!_this.hasForward()) return false;
      var crt = {
        workspace: _this.state.workspace,
        path: _this.state.path
      };

      _this.history.back.push(crt);

      var lastEntry = _this.history.forward[0];

      _this.history.forward.shift();

      _this.setState(lastEntry);

      return true;
    };

    _this.getDefaultDataGridSelection = function () {
      if (typeof _this.props.defaultSelection !== 'undefined') {
        var visibleSelection = _this.props.defaultSelection.map(stripDesignTrunkFromPath).filter(function (path) {
          if (isFile(path)) return getFolderPath(_this.state.path) === getFolderPath(path);else if (isFolder(path)) return getFolderPath(_this.state.path) === getParentFolderPath(path);
        }).map(addDesignTrunk);

        return visibleSelection;
      } else {
        return undefined;
      }
    };

    _this.handleChange = function (e, selection) {
      var _this$state = _this.state,
          submitAction = _this$state.submitAction,
          submitActionEnabled = _this$state.submitActionEnabled; //selection contains undefined when data is not fetched
      // e.g. when using default paths

      var hasSelectionData = selection && selection.length > 0 && selection.indexOf(undefined) === -1;

      if (hasSelectionData) {
        _this.gridSelection = selection;
        _this.selection = selection.filter(function (i) {
          return i.ItemType === _this.props.pickType;
        }).map(function (i) {
          return {
            path: getItemPath(i),
            workspace: i.Workspace,
            resourceToken: i.ResourceToken
          };
        });
        if (selection.length === 1 && selection[0].ItemType === 'folder' && _this.props.pickType === 'file' && e.selectionType === 'click') return _this.handleItemDoubleClick(e, selection[0]);
        var canSelect = selection.length === selection.filter(function (i) {
          return i.ItemType === _this.props.pickType;
        }).length;

        if (canSelect) {
          submitAction = 'select';
          if (selection.length > 0) submitActionEnabled = true;else submitActionEnabled = false;
        } else {
          if (_this.props.pickType === 'file') {
            var selectedFolders = selection.filter(function (i) {
              return i.ItemType === 'folder';
            });

            if (!_this.state.workspace || selectedFolders.length === 1) {
              submitAction = 'open';
              submitActionEnabled = true;
            } else {
              submitAction = 'open';
              submitActionEnabled = false;
            }
          } else {
            submitActionEnabled = false;
          }
        }
      } else {
        _this.gridSelection = [];
        _this.selection = [];
        submitActionEnabled = false;
      }

      _this.setState({
        submitAction: submitAction,
        submitActionEnabled: submitActionEnabled
      });
    };

    _this.getSelectedFolderPath = function () {
      var selectedFolders = _this.gridSelection.filter(function (i) {
        return i.ItemType === 'folder';
      });

      if (selectedFolders.length) return getItemPath(selectedFolders[0]);
      return null;
    };

    _this.getSelectedWorkspace = function () {
      if (_this.gridSelection[0]) return _this.gridSelection[0].Name;
      return null;
    };

    _this.handleSubmit = function () {
      if (_this.state.submitAction === 'select') {
        _this.props.onChange(_this.selection);
      } else if (_this.state.submitAction === 'open') {
        if (!_this.state.workspace) return;else _this.handleChangePath(_this.getSelectedFolderPath());
      }
    };

    _this.handleItemDoubleClick = function (e, item) {
      if (!_this.state.workspace) return;

      if (_this.props.pickType === 'file') {
        if (item.ItemType === 'file') _this.props.onChange(_this.selection);else if (item.ItemType === 'folder') _this.handleChangePath(getItemPath(item));
      } else if (_this.props.pickType === 'folder') {
        if (item.ItemType === 'folder') _this.handleChangePath(getItemPath(item));
      }
    };

    _this.handleChangePath = function (path) {
      _this.navigateToPath(path);
    };

    _this.handleOpenFolder = function (e, item) {
      if (item.ItemType === 'folder') _this.handleChangePath(getItemPath(item));
    };

    _this.getBreadcrumbPath = function () {
      var _this$state2 = _this.state,
          workspace = _this$state2.workspace,
          path = _this$state2.path;
      if (!workspace) return '';
      var displayPath = workspace;

      if (path) {
        if (displayPath) displayPath = displayPath + '/' + path;else displayPath = path;
      }

      return displayPath;
    };

    _this.handleChangeBreadcrumbsPath = function (path) {
      var segments = path.split('/');
      var workspace = segments.shift();
      if (workspace !== _this.state.workspace) _this.navigateToWorkspace(workspace);
      var newPath = segments.join('/');
      return _this.handleChangePath(newPath);
    };

    _this.handleChangeWorkspace = function (value) {
      _this.navigateToWorkspace(value);
    };

    _this.handleCloseWindow = function (e) {
      if (_this.props.onClose) _this.props.onClose(e);
    };

    _this.handleNewFolder = function (e) {
      if (!_this.state.workspace) return false;
      Modal.open({
        type: Modal.TYPES.PROMPT_INPUT,
        props: {
          windowProps: {
            header: 'New Folder'
          },
          formFieldType: 'Name',
          formField: {
            label: 'Folder Name',
            type: 'folderPath',
            placeholder: 'Name or path'
          },
          submitLabel: 'Create',
          submittingLabel: 'Creating..',
          onSubmit: function onSubmit(folderName) {
            //create path
            return DataAction.item({
              dataType: 'repository',
              dataProps: {
                type: 'folder'
              }
            }).create({
              Workspace: _this.state.workspace,
              Path: _this.state.path + '/' + folderName
            }).then(function (action) {
              if (!action.failed) _this.handleChangePath(getItemPath(action.payload));
              return action;
            });
          }
        }
      });
      return true;
    };

    _this.handleNewImage = function (path, workspace) {
      Modal.open({
        type: Modal.TYPES.WEB_CAM,
        props: {
          title: 'Take a photo',
          onConfirm: function onConfirm(base64) {
            fetch(base64).then(function (res) {
              return res.blob();
            }).then(function (blob) {
              var file = new File([blob], 'Capture.jpeg', {
                type: 'image/jpeg'
              });
              return DataAction.item({
                dataType: 'repository',
                dataProps: {
                  type: 'file'
                }
              }).create({
                workspace: workspace,
                folderPath: path,
                files: [file]
              });
            });
          }
        }
      });
    };

    _this.detectWebcam = function (callback) {
      var md = navigator.mediaDevices;
      if (!md || !md.enumerateDevices) return callback(false);
      md.enumerateDevices().then(function (devices) {
        callback(devices.some(function (device) {
          return 'videoinput' === device.kind;
        }));
      });
    };

    _this.renderFooter = function () {
      var _this$state3 = _this.state,
          submitAction = _this$state3.submitAction,
          submitActionEnabled = _this$state3.submitActionEnabled,
          workspace = _this$state3.workspace,
          path = _this$state3.path,
          hasCamera = _this$state3.hasCamera;
      var isMobile = isMobileDevice();
      var allowImageFromCamera = hasCamera && !isMobile && _this.props.allowImageFromCamera;
      return React.createElement(Grid, {
        container: true,
        direction: "row"
      }, React.createElement(Grid, {
        item: true,
        xs: true
      }, workspace && React.createElement(Grid, {
        container: true,
        direction: "row",
        spacing: 1
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(RepositoryUpload, {
        workspace: workspace,
        path: path,
        multi: true,
        maxSize: _this.props.maxUploadSize,
        accept: _this.accept,
        optimizeImageWeb: _this.props.optimizeImageWeb,
        widthHeightMaxLimit: _this.props.widthHeightMaxLimit
      }, React.createElement(Button, {
        variant: "outlined",
        className: _this.props.classes.buttonsGrey
      }, React.createElement(Icon, {
        type: "upload",
        style: {
          fontSize: '1rem',
          marginRight: 8 / 2
        }
      }), "Upload File"))), allowImageFromCamera && React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        className: _this.props.classes.buttonsGrey,
        variant: "outlined",
        onClick: function onClick() {
          return _this.handleNewImage(path, workspace);
        }
      }, React.createElement(Icon, {
        type: "image",
        style: {
          fontSize: '1rem',
          marginRight: 8 / 2
        }
      }), "Camera")), React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        variant: "outlined",
        onClick: _this.handleNewFolder,
        className: _this.props.classes.buttonsGrey
      }, React.createElement(Icon, {
        type: "folder",
        style: {
          fontSize: '1rem',
          marginRight: 8 / 2
        }
      }), "New Folder")))), React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: _this.handleSubmit,
        disabled: !submitActionEnabled
      }, submitAction === 'select' ? _this.selection && _this.selection.length > 1 ? 'Select (' + _this.selection.length + ')' : 'Select' : submitAction === 'open' ? 'Open' : '?')));
    };

    _this.renderHeader = function () {
      return React.createElement(Typography, {
        variant: "h5"
      }, "Choose ", getTypeFriendlyName(_this.props));
    };

    _this.renderBreadcrumbs = function () {
      var displayPath = _this.getBreadcrumbPath();

      return React.createElement(React.Fragment, null, React.createElement(Grid, {
        container: true,
        direction: "row",
        style: {
          position: 'sticky',
          top: 0,
          zIndex: 3,
          backgroundColor: 'white' //theme.palette.background

        }
      }, React.createElement(Grid, {
        item: true
      }, _this.renderNavigation()), React.createElement(Grid, {
        item: true,
        xs: true
      }, React.createElement(Breadcrumbs, {
        darkColor: true,
        path: displayPath,
        onNavigateTo: _this.handleChangeBreadcrumbsPath,
        editable: true,
        style: {
          padding: 8,
          //theme.spacing(1)
          paddingLeft: 0
        }
      })), React.createElement(Grid, {
        style: {
          width: 80
        }
      }, React.createElement(DataGrid.ModeSwitcher, {
        id: _this.getDataGridId()
      }))), React.createElement("div", {
        //shadow
        style: {
          position: 'sticky',
          top: 0,
          marginTop: -40,
          //height of the breadcrumb
          height: 40,
          width: '100%',
          zIndex: 1,
          boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px' //z1

        }
      }), React.createElement("div", {
        //cover the shadow
        style: {
          position: 'sticky',
          backgroundColor: 'white',
          //theme.palette.background
          marginTop: -4,
          //shadow size
          top: 4,
          //shadow size
          width: '100%',
          height: 6,
          //shadow size
          zIndex: 2
        }
      }));
    };

    _this.getDataGridId = function () {
      var _this$state4 = _this.state,
          workspace = _this$state4.workspace,
          path = _this$state4.path,
          extensions = _this$state4.extensions;
      return "picker-".concat(workspace, "-").concat(path, "-").concat(extensions.join(',') || '*');
    };

    _this.renderNavigation = function () {
      return React.createElement(NavigationButtonGroup, {
        hasUp: _this.hasUp(),
        hasBack: _this.hasBack(),
        hasForward: _this.hasForward(),
        onUp: _this.goUp,
        onBack: _this.goBack,
        onForward: _this.goForward
      });
    };

    _this.renderContent = function () {
      var _this$state5 = _this.state,
          workspace = _this$state5.workspace,
          path = _this$state5.path,
          extensions = _this$state5.extensions;
      var _this$props = _this.props,
          multiSelection = _this$props.multiSelection,
          lockWorkspace = _this$props.lockWorkspace,
          maxUploadSize = _this$props.maxUploadSize;
      var _this$props2 = _this.props,
          optimizeImageWeb = _this$props2.optimizeImageWeb,
          widthHeightMaxLimit = _this$props2.widthHeightMaxLimit;
      return React.createElement(React.Fragment, null, React.createElement(RepositoryUpload, {
        workspace: workspace,
        path: path,
        multi: true,
        disableClick: true,
        style: {
          display: 'block'
        },
        maxSize: maxUploadSize,
        accept: _this.accept,
        optimizeImageWeb: optimizeImageWeb,
        widthHeightMaxLimit: widthHeightMaxLimit
      }, React.createElement(HotKeys, {
        keyMap: KEY_MAP,
        handlers: _this.keyHandlers,
        style: {
          outline: 'none'
        }
      }, !lockWorkspace && React.createElement(Grid, {
        container: true,
        direction: "row",
        alignItems: "center",
        style: {
          marginTop: 4,
          marginBottom: 4
        }
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(InputLabel, {
        shrink: true,
        htmlFor: "workspace",
        style: {
          marginLeft: 16,
          marginRight: 8,
          fontSize: '.8rem'
        }
      }, "Workspace")), React.createElement(Grid, {
        item: true,
        style: {
          width: 150
        }
      }, React.createElement(DataSelectFormInput, {
        id: "workspace",
        dataType: "workspace",
        placeholder: "Pick workspace",
        name: "workspace",
        onChange: _this.handleChangeWorkspace,
        value: workspace
      }))), _this.renderBreadcrumbs(), workspace ? React.createElement(RootRef, {
        rootRef: _this.gridViewRef
      }, React.createElement(DataGrid, {
        key: _this.getDataGridId(),
        id: _this.getDataGridId(),
        dataType: "repository",
        dataProps: {
          workspace: workspace,
          path: path,
          filter: {
            extensions: extensions,
            onlyFolders: _this.props.pickType === 'folder'
          }
        },
        selectable: true,
        onSelect: _this.handleChange,
        onDoubleClick: _this.handleItemDoubleClick,
        multiSelection: multiSelection,
        defaultSelection: _this.getDefaultDataGridSelection(),
        styles: {
          elevation: 0
        },
        viewProps: {
          hideModeSwitcher: true,
          style: {
            backgroundColor: PICKER_BACKGROUND
          }
        },
        contextMenu: [{
          type: 'open',
          hidden: function hidden(item) {
            return item && item.ItemType !== 'folder';
          },
          onClick: _this.handleOpenFolder
        }, {
          type: 'rename'
        }, 'separator', {
          type: 'delete'
        }]
      })) : React.createElement("div", {
        style: {
          height: 100,
          backgroundColor: PICKER_BACKGROUND
        }
      }), React.createElement("div", {
        style: {
          paddingBottom: 8 * 3,
          backgroundColor: PICKER_BACKGROUND
        }
      }))));
    };

    _this.selection = [];
    _this.gridSelection = [];

    var _workspace = props.workspace || 'Default';

    var _path = '';
    if (props.path) _path = stripDesignTrunkFromPath(getFolderPath(props.path));
    _this.state = {
      workspace: _workspace,
      path: _path,
      hasCamera: false,
      submitAction: 'select',
      // 'open'
      submitActionEnabled: false,
      extensions: getTypeExtensions(props)
    };
    var _extensions = _this.state.extensions;
    _this.accept = _extensions && _extensions.length ? _extensions.map(function (ext) {
      return ".".concat(ext);
    }).join(',') : null;
    _this.history = {
      back: [],
      forward: []
    }; //populate history so that the user can press backspace and go up to the root

    _this.history.back = _path.split('/').map(function (seg, idx) {
      return {
        workspace: _workspace,
        path: _path.split('/').slice(0, idx).join('/')
      };
    });
    _this.gridViewRef = React.createRef();
    _this.keyHandlers = {
      NAVIGATE_UP: function NAVIGATE_UP(e) {
        var ok = _this.goUp(e);

        if (ok) return false;
      },
      NEW_FOLDER: function NEW_FOLDER(e) {
        var ok = _this.handleNewFolder(e);

        if (ok) return false;
      },
      BACK: function BACK(e) {
        var ok = _this.goBack(e);

        if (ok) return false;
      },
      FORWARD: function FORWARD(e) {
        var ok = _this.goForward(e);

        if (ok) return false;
      }
    };
    return _this;
  }

  _createClass(RepositoryPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.detectWebcam(function (hasCamera) {
        this.setState({
          hasCamera: hasCamera
        });
      }.bind(this));

      if (typeof this.props.defaultSelection !== 'undefined') {
        this.handleChange({
          type: 'defaultSelection'
        }, this.props.defaultSelection.map(function (path) {
          return {
            Path: path,
            Workspace: _this2.state.workspace,
            ResourceToken: '',
            ItemType: path.indexOf('.') > -1 ? 'file' : 'folder'
          };
        }));
      }

      setTimeout(function () {
        _this2.focus();
      }, 0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (document.activeElement === document.body) this.focus();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ModalWindow, {
        id: "RepositoryPicker",
        elevation: 3,
        style: {
          minWidth: 480,
          width: '75%'
        },
        renderFooter: this.renderFooter,
        renderHeader: this.renderHeader,
        renderContent: this.renderContent,
        onClose: this.handleCloseWindow
      });
    }
  }]);

  return RepositoryPicker;
}(React.Component);

RepositoryPicker.defaultProps = {
  multiSelection: false,
  lockWorkspace: false,
  pickType: 'file',
  fileExtensions: null,
  fileTypes: null,
  path: '',
  defaultSelection: [],
  classes: []
};
export default withStyles(styles, {
  name: 'ECRepositoryPickerButtons'
})(RepositoryPicker);